import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { MediaTag } from '@src/api/types/mediaTag';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

type MediaTagIndexResponse = {
  data: MediaTag[];
  pagination: Pagination;
};
type MediaTagRequest = {
  name?: string;
  enabled?: boolean | number;
};
type MediaTagResponse = MediaTag;
export const mediaTagApiClient = {
  index: async (params: IndexRequest = {}): Promise<ApiResult<MediaTagIndexResponse>> => {
    return await axiosClient.get('/tenant/media-tags', { params });
  },
  suggest: async (): Promise<ApiResult<MediaTag[]>> => {
    return await axiosClient.get('/tenant/media-tags/suggest');
  },
  show: async (id: number): Promise<ApiResult<MediaTag>> => {
    return await axiosClient.get(`/tenant/media-tags/${id}`);
  },
  create: async (params: MediaTagRequest): Promise<ApiResult<MediaTagResponse>> => {
    return await axiosClient.post('/tenant/media-tags', params);
  },
  update: async (id: number, params: MediaTagRequest): Promise<ApiResult> => {
    return await axiosClient.put(`/tenant/media-tags/${id}`, params);
  },
};
